import * as Turbo from '@hotwired/turbo';
import { registerSvelteControllerComponents } from '@symfony/ux-svelte';
import 'core-js/actual/structured-clone';
import './js/sentry.js';
import('flatpickr/dist/themes/light.css');

Turbo.session.drive = false;

import '@splidejs/splide/css';
import './css/main.scss';

// start the Stimulus application
import { startStimulusApp } from '@symfony/stimulus-bridge';

// Registers Stimulus controllers from controllers.json and in the controllers/ directory
export const app = startStimulusApp();

// common
import AccordionController from './controllers/accordion_controller.js';
import ModalController from './controllers/modal_controller.js';
// saga
import AlertAvailabilitiesBoxController from './controllers/alertAvailabilities_box_controller.js';
import AutosubmitFormController from './controllers/autosubmit_form_controller.js';
import BookingHelpCenterController from './controllers/booking_help_center_controller.js';
import CarouselController from './controllers/carousel_controller.js';
import DatepickerController from './controllers/datepicker_controller.js';
import FeedbackBoxController from './controllers/feedback_box_controller.js';
import FetchReviewsController from './controllers/fetch_reviews_controller.js';
import FormSpinnerController from './controllers/form_spinner_controller.js';
import InputCounterController from './controllers/input_counter_controller.js';
import InputNumberController from './controllers/input_number_controller.js';
import LightboxModalController from './controllers/lightbox_modal_controller.js';
import MenuDesktopController from './controllers/menu_desktop_controller.js';
import MenuMobileController from './controllers/menu_mobile_controller.js';
import ObfuscatorController from './controllers/obfuscator_controller.js';
import PaxSelectorController from './controllers/pax_selector_controller.js';
import PdpCarouselController from './controllers/pdp_carousel_controller.js';
import PdpMosaicCarouselController from './controllers/pdp_mosaic_carousel_controller.js';
import PopoverController from './controllers/popover_controller.js';
import SeeMoreController from './controllers/see_more_controller.js';
import ShowmoreController from './controllers/showmore_controller.js';
import TourNavController from './controllers/tour_nav_controller.js';
import TravelTourController from './controllers/travel_tour_controller.js';
import WordCountController from './controllers/wordcount_controller.js';

// Register each controller
app.register('accordion', AccordionController);
app.register('alertAvailabilities-box', AlertAvailabilitiesBoxController);
app.register('autosubmit-form', AutosubmitFormController);
app.register('booking-help-center', BookingHelpCenterController);
app.register('carousel', CarouselController);
app.register('datepicker', DatepickerController);
app.register('feedback-box', FeedbackBoxController);
app.register('fetch-reviews', FetchReviewsController);
app.register('form-spinner', FormSpinnerController);
app.register('input-counter', InputCounterController);
app.register('input-number', InputNumberController);
app.register('lightbox-modal', LightboxModalController);
app.register('menu-desktop', MenuDesktopController);
app.register('menu-mobile', MenuMobileController);
app.register('modal', ModalController);
app.register('obfuscator', ObfuscatorController);
app.register('pax-selector', PaxSelectorController);
app.register('pdp-carousel', PdpCarouselController);
app.register('pdp-mosaic-carousel', PdpMosaicCarouselController);
app.register('popover', PopoverController);
app.register('showmore', ShowmoreController);
app.register('see-more', SeeMoreController);
app.register('tour-nav', TourNavController);
app.register('travel-tour', TravelTourController);
app.register('wordcount', WordCountController);

// Import Svelte components individually
import TourAsidePanel from './svelte/saga/controllers/TourAsidePanel.svelte';
import TourBudgetPlanePricingOnCustomerController from './svelte/saga/controllers/TourBudgetPlanePricingOnCustomerController.svelte';
import TourFeatures from './svelte/saga/controllers/TourFeatures.svelte';
import TourFitVisibleDates from './svelte/saga/controllers/TourFitVisibleDates.svelte';
import TourGirVisibleDates from './svelte/saga/controllers/TourGirVisibleDates.svelte';

// Create a custom context function that behaves like require.context for registerSvelteControllerComponents to work
const customContext = function (key) {
    return customContext._components[key];
};

customContext._components = {
    './TourAsidePanel.svelte': { default: TourAsidePanel },
    './TourFeatures.svelte': { default: TourFeatures },
    './TourGirVisibleDates.svelte': { default: TourGirVisibleDates },
    './TourFitVisibleDates.svelte': { default: TourFitVisibleDates },
    './TourBudgetPlanePricingOnCustomerController.svelte': {
        default: TourBudgetPlanePricingOnCustomerController,
    },
};

customContext.keys = function () {
    return Object.keys(this._components);
};

// Register our Svelte components
registerSvelteControllerComponents(customContext);
